module.exports = __webpack_public_path__ + "img/featuredartist (7).a33b3ec3.jpg";